export default "__VITE_ASSET__CsXUOD0i__"